import React, { useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";

export default function StatusSelectionComponent({
  handleClose,
  handleoK,
  //   headerTitle,
}) {
  const { localization } = useLanguageContext();
  const [selectedStatus, setSelectedStatus] = useState("");

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  return (
    <div
      className="modal in dialogBox"
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content"
          style={{
            padding: 32,
            background: "#FBFCFE",
            borderRadius: 8,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <div
            className="modal-header"
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div
              style={{
                color: "#0B6BCB",
                fontSize: 36,
                fontFamily: "Inter",
                fontWeight: 700,
                lineHeight: "47.88px",
                wordWrap: "break-word",
              }}
            >
              {localization.selectStatus}
            </div>
          </div>
          <div
            className="modal-body"
            style={{
              paddingBottom: 20,
              display: "flex",
              alignItems: "flex-start",
              gap: 32,
            }}
          >
            <div
              style={{
                width: 646,
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <label className="fontStyleLabel">
                <input
                  className="mr-5"
                  type="radio"
                  value="Active"
                  checked={selectedStatus === "Active"}
                  onChange={handleStatusChange}
                />
                {localization.active}
              </label>
              <label className="fontStyleLabel">
                <input
                  type="radio"
                  value="OutOperation"
                  checked={selectedStatus === "OutOperation"}
                  onChange={handleStatusChange}
                  className="mr-5"
                />
                {localization.inActive}
              </label>
            </div>
          </div>
          <div
            className="modal-footer py-3"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              borderTop: "1px rgba(99, 107, 116, 0.30) solid",
              paddingTop: 20,
            }}
          >
            <button
              style={{
                padding: "4px 16px",
                background: "#FCE4E4",
                borderRadius: 6,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                border: "none",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              <div
                style={{
                  color: "#7D1212",
                  fontSize: 14,
                  fontFamily: "Inter",
                  fontWeight: 600,
                  lineHeight: "14px",
                  wordWrap: "break-word",
                }}
              >
                {localization.exit}
              </div>
            </button>
            <button
              style={{
                padding: "4px 16px",
                background: selectedStatus ? "#E3FBE3" : "#E3FBE3",
                borderRadius: 6,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                border: "none",
                cursor: selectedStatus ? "pointer" : "not-allowed",
              }}
              disabled={!selectedStatus}
              onClick={() => handleoK(selectedStatus)}
            >
              <div
                style={{
                  color: selectedStatus ? "#0A470A" : "#ccc",
                  fontSize: 14,
                  fontFamily: "Inter",
                  fontWeight: 600,
                  lineHeight: "14px",
                  wordWrap: "break-word",
                }}
              >
                {localization.processed}
                {/* {headerTitle} */}
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
